import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import { ActionButton } from 'components/ActionButton/ActionButton';

import './TenantSwitchButton.sass';

export const TenantSwitchButton = ({ onClick, className }) => {
  const classes = classNames('tenant-switch-button', {
    [className]: !!className,
  });

  return <ActionButton title="Portalwechsel" onClick={onClick} className={classes} inverted />;
};

TenantSwitchButton.propTypes = {
  onClick: PropTypes.func,
  className: PropTypes.string,
};

TenantSwitchButton.defaultProps = {
  onClick: () => {},
  className: '',
};
